export default "__VITE_ASSET__CIJRTIEu__"